import React from "react";
import PropTypes from "prop-types";
import "../DataFolder/DataFolder.css";
import {   COLUMN_WIDTH, COLUMN_STYLE, DEFAULT_COLUMN_WIDTH, } 
  from "../../constants/columnConfig";


const DetailSearchResult = ({
  headers = [],
  data = [],
  currentPage,
  pageGroup,
  totalPages,
  totalCount = 0,
  setCurrentPage,
  setPageGroup,
  onPageChange,
  handleDocumentView,
  isFetchingCount
}) => {
  return (
    <>
      {/* Table Container */}
      <div className="document-data__count">
        <span>件数：</span>

        {isFetchingCount ? (
          <span className="count-loading">
            <span className="count-spinner"></span>
          </span>
        ) : (
          <span>{totalCount.toLocaleString()}</span>
        )}
      </div> 

      <div className="document-table__container">
        <table className="document-table__table">
          <thead>
            <tr>
              {headers
                ?.sort((a, b) => a.display_idx - b.display_idx)
                .map((col, idx) => (
                  <th
                    key={idx}
                    style={{
                      width: COLUMN_WIDTH[col.pattern_name] || DEFAULT_COLUMN_WIDTH,
                      ...(COLUMN_STYLE[col.pattern_name] || {}),
                    }}
                  >
                    {col.pattern_text}
                  </th>
                ))}
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {headers
                    ?.sort((a, b) => a.display_idx - b.display_idx)
                    .map((header, colIndex) => {
                      let value = "";

                      if (header.pattern_name === "issue_date") {
                        value = row.issue_datetime
                          ? row.issue_datetime.split(" ")[0]
                          : "";
                      } else if (header.pattern_name === "auto_number") {
                        const prefix = row.folder_edition
                          ? row.folder_edition + "-"
                          : "";
                        value = prefix + (row.auto_number || "");
                      } else {
                        value = row[header.pattern_name] ?? "";
                      }

                      return (
                        <td
                          key={colIndex}
                          title={value}
                          style={{
                            width: COLUMN_WIDTH[header.pattern_name] || DEFAULT_COLUMN_WIDTH,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            ...(COLUMN_STYLE[header.pattern_name] || {}),
                          }}
                        >
                          {header.pattern_name === "title" ? (
                            <span
                              className="document-link"
                              style={{
                                color: "#0091a7",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() => handleDocumentView(row)}
                            >
                              {value}
                            </span>
                          ) : (
                            value
                          )}
                        </td>
                      );
                    })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} style={{ textAlign: "center" }}>
                  データがありません。
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 0 && (
        <div className="pagination-container">
          <div className="pagination">
            {pageGroup > 0 && (
              <button
                onClick={() => setPageGroup(pageGroup - 1)}
                className="pagination-arrow"
              >
                &laquo;
              </button>
            )}

            {Array.from(
              { length: Math.min(10, totalPages - pageGroup * 10) },
              (_, i) => {
                const page = pageGroup * 10 + i + 1;
                return (
                  <button
                    key={page}
                    className={`pagination-btn ${
                      page === currentPage ? "active" : ""
                    }`}
                    onClick={() => onPageChange(page)}
                  >
                    {page}
                  </button>
                );
              }
            )}

            {(pageGroup + 1) * 10 < totalPages && (
              <button
                onClick={() => setPageGroup(pageGroup + 1)}
                className="pagination-arrow"
              >
                &raquo;
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

DetailSearchResult.propTypes = {
  headers: PropTypes.array,
  data: PropTypes.array,
  currentPage: PropTypes.number,
  pageGroup: PropTypes.number,
  totalPages: PropTypes.number,
  setCurrentPage: PropTypes.func,
  setPageGroup: PropTypes.func,
  onPageChange: PropTypes.func.isRequired,
};

export default DetailSearchResult;
